import { render } from "./NotificationIndex.vue?vue&type=template&id=bf5f8348"
import script from "./NotificationIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/notification/components/NotificationIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf5f8348"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf5f8348', __exports__)) {
    api.reload('bf5f8348', __exports__)
  }
  
  module.hot.accept("./NotificationIndex.vue?vue&type=template&id=bf5f8348", () => {
    api.rerender('bf5f8348', render)
  })

}


export default __exports__